export default "//cdn.scentbird.com/assets/frontbird-site/images/tom-ford_bbd758.png";